import type { PropertyListItemDto } from '../../services/api';
import { t } from '../../services/i18n';
import { PROPERTY_ICONS, type PropertyViewMode, renderPropertyCard, renderPropertyTable } from './property-shared';

export class RcPropertyListView extends HTMLElement {
  properties: PropertyListItemDto[] = [];
  viewMode: PropertyViewMode = 'cards';

  connectedCallback(): void {
    this.addEventListener('click', this.handleClick);
    this.render();
  }

  disconnectedCallback(): void {
    this.removeEventListener('click', this.handleClick);
  }

  render(): void {
    this.innerHTML = `
      <div class="page-header">
        <h1>${t('nav.properties')}</h1>
        <div style="display:flex;gap:0.5rem;align-items:center;">
          <button class="btn btn-outline" data-action="import">
            ${PROPERTY_ICONS.import}
            ${t('property.import')}
          </button>
          <div class="view-toggle">
            <button class="view-toggle-btn ${this.viewMode === 'cards' ? 'active' : ''}" data-action="view-cards" title="${t('property.cardView')}">${PROPERTY_ICONS.grid}</button>
            <button class="view-toggle-btn ${this.viewMode === 'list' ? 'active' : ''}" data-action="view-list" title="${t('property.listView')}">${PROPERTY_ICONS.list}</button>
          </div>
          <button class="btn btn-primary" data-action="add">
            ${PROPERTY_ICONS.plus}
            ${t('property.add')}
          </button>
        </div>
      </div>
      ${this.properties.length === 0
        ? `<div class="empty-state card">
            ${PROPERTY_ICONS.home}
            <p>${t('property.empty')}</p>
            <div style="display:flex;gap:0.75rem;flex-wrap:wrap;justify-content:center;">
              <button class="btn btn-primary" data-action="add">${t('property.addFirst')}</button>
              <button class="btn btn-outline" data-action="import">${t('property.import')}</button>
            </div>
          </div>`
        : this.viewMode === 'cards'
          ? `<div class="card-grid">${this.properties.map((property) => renderPropertyCard(property)).join('')}</div>`
          : renderPropertyTable(this.properties)}
    `;
  }

  private handleClick = (event: Event): void => {
    const target = (event.target as HTMLElement | null)?.closest<HTMLElement>('[data-action]');
    if (!target) return;

    if (['edit', 'delete', 'open-tab', 'quick-add'].includes(target.dataset.action || '')) {
      event.stopPropagation();
    }

    this.dispatchEvent(new CustomEvent(`property-list-${target.dataset.action}`, {
      bubbles: true,
      detail: {
        propertyId: target.dataset.id,
        tab: target.dataset.tab,
        autoAction: target.dataset.auto,
      },
    }));
  };
}

if (!customElements.get('rc-property-list-view')) {
  customElements.define('rc-property-list-view', RcPropertyListView);
}
